import {
  emitErrorToast,
  emitSuccessToast,
} from "./ToastEmitController";
import { Decrypt, Encrypt } from "./EncryptionController";
import axios from "axios";

async function decryptPasswords(keyMaterial, credList) {
  for (const item of credList) {
    item.password = await Decrypt(keyMaterial, item.password);
  }
}

export async function getCredList(keyMaterial, setCredList) {
  axios
    .get(`${process.env.REACT_APP_SERVER_URL}/credentials/get`, {
      withCredentials: true,
    })
    .then(async (response) => {
      await decryptPasswords(keyMaterial, response.data);
      setCredList(response.data);
    })
    .catch((error) => {
      console.error(error);
    });
}

export async function addCredItem(
  keyMaterial,
  newCredItem,
  credList,
  setCredList
) {
  if (
    !newCredItem ||
    newCredItem?.name === "" ||
    newCredItem?.website === "" ||
    newCredItem?.username === "" ||
    newCredItem?.password === ""
  ) {
    emitErrorToast("Error: all fields are required.");
    return false;
  }

  try {
    const newCredItemCopy = { ...newCredItem };
    newCredItemCopy.password = await Encrypt(
      keyMaterial,
      newCredItemCopy.password
    );
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/credentials/add`,
      newCredItemCopy,
      {
        withCredentials: true,
      }
    );
    response.data.password = await Decrypt(keyMaterial, response.data.password);
    setCredList([...credList, response.data]);
    emitSuccessToast("Credential added successfully.")
    return true;
  } catch (error) {
    Array.isArray(error?.response?.data)
      ? error?.response?.data?.forEach((error) => {
          emitErrorToast(error.message);
        })
      : emitErrorToast("Error: failed to add credential.");
    return false;
  }
}

export async function updateCredItem(
  keyMaterial,
  credItem,
  index,
  credList,
  setCredList
) {
  if (
    !credItem ||
    credItem?.name === "" ||
    credItem?.website === "" ||
    credItem?.username === "" ||
    credItem?.password === ""
  ) {
    emitErrorToast("Error: all fields are required.");
    return false;
  }

  try {
    const credItemCopy = { ...credItem };
    credItemCopy.password = await Encrypt(keyMaterial, credItemCopy.password);
    const response = await axios.put(
      `${process.env.REACT_APP_SERVER_URL}/credentials/update/${credItem._id}`,
      credItemCopy,
      {
        withCredentials: true,
      }
    );
    const newCredList = [
      ...credList.slice(0, index),
      credItem,
      ...credList.slice(index + 1),
    ];
    setCredList(() => newCredList);
    emitSuccessToast(response.data.message);
    return true;
  } catch (error) {
    Array.isArray(error?.response?.data)
      ? error?.response?.data?.forEach((error) => {
          emitErrorToast(error.message);
        })
      : emitErrorToast("Error: failed to add credential.");
    return false;
  }
}

export async function deleteCredItem(cred_id, index, credList, setCredList) {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_SERVER_URL}/credentials/delete/${cred_id}`,
      {
        withCredentials: true,
      }
    );
    const newCredList = [...credList];
    newCredList.splice(index, 1);
    setCredList(() => newCredList);
    emitSuccessToast(response.data.message);
    return true;
  } catch (error) {
    emitErrorToast("Error: failed to delete credential.");
    console.error(error);
    return false;
  }
}
